import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import CourseSearch from '../components/CourseSearch';
import type { CompactCourseModel } from '@/models/CourseModels';
import usePageTitle from '../hooks/usePageTitle';

const CourseSearchView: React.FC = () => {
    const navigate = useNavigate();
    const { theme } = useTheme();

    // Set static page title
    usePageTitle('Find a Course');

    return (
        <div style={{ padding: theme.spacing.MEDIUM }}>
            <h1 style={{
                color: theme.colors.TEXT,
                marginBottom: theme.spacing.LARGE,
                textAlign: 'center'
            }}>
                Find a Course
            </h1>
            <CourseSearch
                onCourseSelect={(course: CompactCourseModel) => {
                    navigate(`/course/${course.i}`);
                }}
            />
        </div>
    );
};

export default CourseSearchView; 